namespace CONSTANTS {
    export enum SupportedLanguage {
        FR = 'FR',
        EN = 'EN',
        IT = 'IT',
        ES = 'ES',
    }

    export const LOCAL_STORAGE_KEYS = {
        ACCESS_TOKEN: 'accessToken',
        REFRESH_TOKEN: 'refreshToken',
        UNIXTIMESTAMP_EXPIRES_IN: 'unixTimestamp_expires_in',
        TRY_ON_SIZING: 'tryOnSizing',
    };

    export enum SCREEN {
        HOME = 'HOME',
        PRODUCT_DETAIL = 'PRODUCT_DETAIL',
        CATEGORY = 'CATEGORY',
        SUB_CATEGORY = 'SUB_CATEGORY',
        OUTFITS = 'OUTFITS',
        OUTFIT_DETAIL = 'OUTFIT_DETAIL',
        LOGIN = 'LOGIN',
    }

    export enum CATEGORY_ID {
        WOMEN = 'women',
        MEN = 'men',
    }

    export const API_URL = {
        DEV: 'https://api.dev.spreeai.com',
        // DEV: 'https://api.spreeai.com',
        STAGE: 'https://api.stage.spreeai.com',
        PROD: 'https://api.spreeai.com',
    };

    export const MANAGE_ACCOUNT_URL = {
        DEV: 'https://partners.dev.spreeai.com/login',
        STAGE: 'https://partners.stage.spreeai.com/login',
        PROD: 'https://partner.spreeai.com/login',
    };

    export const FORGOT_PASSWORD_URL = {
        DEV: 'https://partners.dev.spreeai.com/login?action=forgotPassword',
        STAGE: 'https://partners.stage.spreeai.com/login?action=forgotPassword',
        PROD: 'https://partner.spreeai.com/login?action=forgotPassword',
    };

    export const CREATE_ACCOUNT_URL = {
        DEV: 'https://dev.spreeai.com/create-account',
        STAGE: 'https://stage.spreeai.com/create-account',
        PROD: 'https://spreeai.com/create-account',
    };

    export const BRIDGE_URL = {
        LOCAL: 'http://localhost:3000',
        DEV: 'https://vton.dev.spreeai.com',
        STAGE: 'https://vton.stage.spreeai.com',
        PROD: 'https://vton.spreeai.com',
    };

    export const ROUTES = {
        EN: {
            HOME: '/',
            PRODUCT_DETAIL: '/product/:id',
            CATEGORY: '/collections/:category',
            SUB_CATEGORY: '/collections/:category/:subCategory',
            OUTFITS: '/outfits',
            OUTFIT_DETAIL: '/outfits/:id',
            LOGIN: '/auth',
        },
        FR: {
            HOME: '/fr',
            PRODUCT_DETAIL: '/fr/product/:id',
            CATEGORY: '/collections/fr/:category',
            SUB_CATEGORY: '/collections/fr/:category/:subCategory',
            OUTFITS: '/fr/outfits',
            OUTFIT_DETAIL: '/fr/outfits/:id',
            LOGIN: '/fr/auth',
        },
        IT: {
            HOME: '/it',
            PRODUCT_DETAIL: '/it/product/:id',
            CATEGORY: '/collections/it/:category',
            SUB_CATEGORY: '/collections/it/:category/:subCategory',
            OUTFITS: '/it/outfits',
            OUTFIT_DETAIL: '/it/outfits/:id',
            LOGIN: '/it/auth',
        },
        ES: {
            HOME: '/es',
            PRODUCT_DETAIL: '/es/product/:id',
            CATEGORY: '/es/:category',
            SUB_CATEGORY: '/collections/es/:category/:subCategory',
            OUTFITS: '/es/outfits',
            OUTFIT_DETAIL: '/es/outfits/:id',
            LOGIN: '/es/auth',
        },
    };

    export const IS_DEV =
        window.location.hostname === 'localhost' || window.location.hostname.includes('dev');
    export const IS_STAGE = window.location.hostname.includes('stage');
}

export default CONSTANTS;
